'use client'

import { PromoApiPromo } from '@/screens/promo-apipromo'

type Props = {
	blockData: any
}

const PromoPageContent = ({ blockData }: { blockData: any }) => {
	return <>{blockData ? <PromoApiPromo blockData={blockData.promo} productCounter={0} /> : <></>}</>
}

export function PromoClient({ blockData }: Props) {
	return <PromoPageContent blockData={blockData} />
}
